import { postData } from "../../components/FetchServices";
export const saveDetails = async (body) => {
  const result = await postData("api/saveDetails", body);
  if (result?.status === 200) {
    return result;
  }
};
